import React, { PureComponent } from "react";

import Media from "./Media";
import { connect } from "react-redux";

import {
  resetSelectedMedia,
  openDisplayAlbum,
  setSelectedMedia,
  setCurrentAlbum,
  openAlbumEditor,
  setAlbumEditor,
  setEditorAlbum,
  setOpenDeleteAlbum,
  setAlbum
} from "Actions";

import styles from "./Album.local.scss";
import classnames from "classnames";
import _ from "i18n";
import { getDateLabel } from "Utils";
import { fetchAlbum } from "Thunks";

class AlbumComponent extends PureComponent {
  state = {
    loading: false,
    success: false
  };

  renderMedias() {
    const { album, language } = this.props;

    const { medias, countMedias } = album;
    if (!medias) {
      return null;
    }

    return (
      <ul className="grid-x">
        {[...medias].slice(0, 3).map(media => (
          <li className="cell small-3">
            <Media media={media} language={language} />
          </li>
        ))}
        {countMedias > 3 ? (
          <li className={classnames(styles.others, "cell small-3")}>
            + {countMedias - 3}
          </li>
        ) : null}
      </ul>
    );
  }

  handleDeleteAlbum = e => {
    e.stopPropagation();
    e.preventDefault();
    const { album, setAlbum, setOpenDeleteAlbum } = this.props;
    setAlbum(album);
    setOpenDeleteAlbum(true);
  };

  handleEditAlbum = e => {
    e.stopPropagation();
    e.preventDefault();
    const { album, setEditorAlbum, openAlbumEditor, fetchAlbum } = this.props;
    setEditorAlbum(album);
    fetchAlbum({ id: album.id });
    openAlbumEditor();
  };

  handleClickAlbum = e => {
    e.stopPropagation();
    e.preventDefault();
    const {
      album,
      language,
      checks,
      saveAlbum,
      resetSelectedMedia,
      displaySidebarAlbums,
      openDisplayAlbum,
      fetchAlbum,
      setCurrentAlbum,
      setSelectedMedia,
      saveEvent
    } = this.props;
    if (saveEvent) {
      const lngTitle = `title${language.charAt(0).toUpperCase() +
        language.slice(1)}`;
      const lngDesc = `description${language.charAt(0).toUpperCase() +
        language.slice(1)}`;

      this.setState({ loading: true });
      saveAlbum({
        id: album.id,
        title: album[lngTitle],
        description: album[lngDesc],
        mediaIds: checks.map(media => media.id),
        addMedia: true
      }).then(resp => {
        this.setState({ loading: false, success: true });
        resetSelectedMedia();
        setTimeout(e => {
          displaySidebarAlbums(false);
        }, 2000);
      });
      // displaySidebarAlbums(false);

      // $(".check").addClass("disabled");
      // $(".check").css("display", "none");

      // document.getElementById("bubbles").classList.remove("active");

      // const albumArea = document.getElementById("album-area");
      // albumArea &&
      //   window.scrollTo(
      //     0,
      //     albumArea.getBoundingClientRect().top + window.scrollY
      //   );
      // });
    } else {
      setCurrentAlbum(album);
      if (album.medias.length > 0) setSelectedMedia(album.medias[0]);
      fetchAlbum({ id: album.id });
      openDisplayAlbum();
    }
    return false;
  };

  render() {
    const { album, language, saveEvent } = this.props;

    if (!album) {
      return null;
    }

    const titleAttr = `title${language.charAt(0).toUpperCase() +
      language.slice(1)}`;
    return (
      <div
        className={classnames(
          styles.album,
          saveEvent ? styles["album--hover"] : "",
          this.state.success ? styles.success : "",
          this.state.loading ? styles.loading : ""
        )}
        onClick={this.handleClickAlbum}
      >
        {!saveEvent && (
          <ul className={styles.album__actions}>
            <li>
              <button onClick={this.handleEditAlbum}>
                <span className="icotam-edit" />
              </button>
            </li>
            <li>
              <button onClick={this.handleDeleteAlbum}>
                <span className="icotam-trash" />
              </button>
            </li>
          </ul>
        )}

        <div className={styles.album__content}>
          <div className={classnames(styles.medias, "grid-x")}>
            {this.renderMedias()}
          </div>
          <h3>{album[titleAttr]}</h3>
          <span className={styles.album__date}>
            {_("Created at")}
            <span> {getDateLabel(album.createdAt, false)}</span>
          </span>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  resetSelectedMedia: () => dispatch(resetSelectedMedia()),
  openDisplayAlbum: () => dispatch(openDisplayAlbum()),
  openAlbumEditor: () => dispatch(openAlbumEditor()),
  setSelectedMedia: media => dispatch(setSelectedMedia(media)),
  setCurrentAlbum: album => dispatch(setCurrentAlbum(album)),
  fetchAlbum: params => dispatch(fetchAlbum(params)),
  setAlbum: album => dispatch(setAlbum(album)),
  setAlbumEditor: album => dispatch(setAlbumEditor(album)),
  setOpenDeleteAlbum: visible => dispatch(setOpenDeleteAlbum(visible)),
  setEditorAlbum: album => dispatch(setEditorAlbum(album))
});
export default connect(
  null,
  mapDispatchToProps
)(AlbumComponent);



// WEBPACK FOOTER //
// ./src/components/Common/Album/AlbumComponent.js